import axios from 'axios'

export default {
    getDiscover(){
        return axios.get('/discover?is_active=1')
            .then(response => {
                return response.data
            })
    },
    getDiscoverDataSource(params){
        return axios.get('/discover/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getDiscoverbyID(id){
        return axios.get('/discover/' + id)
            .then(response => {
                return response.data
            })
    }, 
    getDiscoverWebView(id){
        return axios.get('/discover/' + id + "/webview")
            .then(response => {
                return response.data
            })
    },       
    createDiscover(formdata){
        return axios.post('/discover', formdata)
            .then(response => {
                return response.data
            })
    },
    updateDiscover(id,formdata){
        return axios.post('/discover/' + id + '/update', formdata  )
            .then(response => {
                return response.data
            })
    },
    deactivateDiscover(id){
        return axios.put('/discover/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateDiscover(id){
        return axios.put('/discover/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    destroyDiscover(id){
        return axios.delete('/discover/' + id)
            .then(response => {
                return response.data
            })
    },
    getDiscoverOrderList(){
        return axios.get('/discover/orderlist')
            .then(response => {
                return response.data
            })
    },
    updateDiscoverOrderList(formdata){
        return axios.post('/discover/updatelist', formdata)
            .then(response => {
                return response.data
            })
    },   
    updateBGImage(id,formData){
        return axios.post('/discover/' + id + '/update_bgimage', formData)
            .then(response => {
                return response.data
            })
    },
    updateCardImage(id,formData){
        return axios.post('/discover/' + id + '/update_cardimage', formData)
            .then(response => {
                return response.data
            })
    },
}